import React from "react";
import { Speaker } from "lucide-react";

/**
 * Get icon for media playback widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getMediaPlaybackIcon = (widget = null) => {
  // Get playback state
  const playbackState = widget?.items?.$w1?.value;
  const isPlaying = playbackState === "playing";

  const lucideIconProps = {
    size: 24,
    style: {
      paddingBottom: "2px",
    },
  };

  return isPlaying ? (
    <Speaker {...lucideIconProps} />
  ) : (
    <Speaker {...lucideIconProps} />
  );
};

export const getMediaPlaybackSubtitle = (widget = null) => {
  if (!widget) return "";

  const playbackState = widget?.items?.$w1?.value;

  if (playbackState) {
    return playbackState.charAt(0).toUpperCase() + playbackState.slice(1);
  }

  return "Stopped";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getMediaPlaybackPatterns = () => {
  return [
    "basic.device.mediaPlayback",
    "basic.device.mediaPlayback1",
    "basic.device.mediaPlayback2",
    "basic.device.mediaPlayback3",
    "basic.device.speaker",
    "basic.device.audioVolume",
  ];
};
